import { combineReducers } from "redux";

import activeModule from "./activeModule";
import additionalComment from "./additionalComment";
import clusterFeature from "./clusterFeature";
import conopsReducer from "./conopsReducer";
import currentScreen from "./currentScreen";
import cycleManagerReducer from "./cycleManager";
import dashboard from "./dashboard";
import featureTableReducer from "./featureTable";
import filters from "./filters";
import geometry from "./geometry";
import knowledgeOfRehabilitation from "./knowledgeOfRehabilitation";
import showLatestUpdates from "./latestUpdates";
import layersLoading from "./layersLoading";
import legendWidget from "./legendWidget";
import mapViewReducer from "./mapViewReducer";
import mobileReducer from "./mobileReducer";
import onboardingReducer from "./onboardingReducer";
import panelFormData from "./panelFormData";
import panelId from "./panelId";
import panelIsSurvey from "./panelIsSurvey";
import panelPageIndex from "./panelPageIndex";
import panelPath from "./panelPath";
import panelPosition from "./panelPosition";
import panelSurveyIsValid from "./panelSurveyIsValid";
import printWidget from "./printWidget";
import sidebarReducer from "./sidebar";
import subCategory from "./subCategory";
import typeOfVehicle from "./typeOfVehicle";
import userReducer from "./userReducer";

const rootReducer = combineReducers({
  additionalComment,
  geometry,
  knowledgeOfRehabilitation,
  subCategory,
  typeOfVehicle,
  currentScreen,
  filters,
  activeModule,
  panelFormData,
  panelPosition,
  panelPath,
  panelPageIndex,
  panelIsSurvey,
  panelSurveyIsValid,
  panelId,
  clusterFeature,
  layersLoading,
  printWidget,
  showLatestUpdates,
  legendWidget,
  dashboard,
  mobileReducer,
  mapViewReducer,
  cycleManagerReducer,
  userReducer,
  featureTableReducer,
  sidebarReducer,
  onboardingReducer,
  conopsReducer,
});

export default rootReducer;
